export const USER_ROLE = {
    customer: 3,
    admin: 1,
    adminRedirect: 8
}
